/* eslint-disable no-nested-ternary */

import React from 'react';
import { VerifiedSymbolIcon } from '@icons';
import { Logo } from '@images';
import { QRCodeCanvas } from 'qrcode.react';

import { Button, Icon, Modal, Tooltip } from '@components';
import { DEFAULT_PLACEHOLDER } from '@constants/generic';
import { MemberTransactionType } from '@types';

interface QuickCollectQrModalProps {
  paymentDetails: MemberTransactionType;
  onClose: () => void;
  isOpen: boolean;
}

const QuickCollectQrModal: React.FC<QuickCollectQrModalProps> = ({
  paymentDetails,
  onClose,
  isOpen
}) => {
  const displayText =
    paymentDetails?.type === 'individual'
      ? paymentDetails?.group_id
        ? `${paymentDetails?.group_name} - ${paymentDetails?.note}`
        : paymentDetails?.note || DEFAULT_PLACEHOLDER
      : paymentDetails?.group_name || DEFAULT_PLACEHOLDER;

  return (
    <Modal
      isOpen={isOpen}
      onCancel={onClose}
      isCloseIconRequired
      className="h-[635px] w-118"
    >
      <div className="flex items-center border-b p-4 pt-6">
        <Button
          handleClick={onClose}
          className="mr-2 text-gray-500 hover:text-gray-700"
          aria-label="Go back"
          variant="transparent"
          size="none"
        >
          <Icon name="back" />
        </Button>
        <h2 className="text-lg font-medium">QR Code</h2>
      </div>

      <div className="flex flex-col items-center p-6">
        <div className="mb-4 text-center">
          <h3
            className="max-w-78 truncate text-lg font-medium"
            data-tooltip-id="user-name"
          >
            {paymentDetails?.name}
          </h3>
          {paymentDetails?.name.length > 20 && (
            <Tooltip
              id="user-name"
              type="text"
              tooltipText={paymentDetails?.name}
              className="max-w-78"
              variant="dark"
            />
          )}
          <p
            className="max-w-78 truncate text-sm font-normal text-grey"
            data-tooltip-id="user-note"
          >
            {displayText}
          </p>
          <Tooltip
            id="user-note"
            type="text"
            variant="dark"
            className="max-w-78"
            tooltipText={displayText}
          />
        </div>
        <div className="relative mb-2 size-64">
          <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2  rounded-full bg-white p-1">
            <Logo className="-ml-0.5 size-9" />
          </div>
          {paymentDetails?.payment_url ? (
            <QRCodeCanvas
              value={paymentDetails?.payment_url}
              bgColor="white"
              fgColor="black"
              marginSize={4}
              size={256}
            />
          ) : (
            <div className="flex size-full items-center justify-center rounded-lg border border-gray-300">
              <p className="text-gray-500">QR Code not available</p>
            </div>
          )}
        </div>

        <p className="mb-6 text-sm text-gray-500">Scan with your camera</p>
      </div>
      <div className="p-6">
        <div className="w-full space-y-3">
          <div className="flex flex-col">
            <div className="flex text-sm text-darkGrey">
              <span>To:</span>
              <span>{paymentDetails?.payment_to}</span>
            </div>
            <div className="flex text-sm text-grey">
              <span>Banking Name:</span>
              <div className="flex items-center gap-1">
                <span> {paymentDetails?.account_name}</span>
                <VerifiedSymbolIcon />
              </div>
            </div>
          </div>

          <div className="flex flex-col text-sm">
            <span className="text-darkGrey">Transaction ID</span>
            <span className="text-grey">{paymentDetails?.id}</span>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default QuickCollectQrModal;
